import script from "./CreateInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateInvoice.vue?vue&type=script&setup=true&lang=js"

import "./CreateInvoice.vue?vue&type=style&index=0&id=09b015f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09b015f6"]])

export default __exports__